export const UserRole = {
  VENDOR: 'vendor',
}
